import { every } from 'lodash-es';

import template from './attribute-filter.component.html';

export class AttributeFilterController {
	constructor() {
		this.displayValidationError = false;
		this.helpContent = '';
	}

	$onInit() {

		this.freeform = this.attr.freeform;
		this.type = this.attr.TYPE;
		this.range = this.attr.range;

		if (!this.attr.selectedValues || this.attr.selectedValues.length === 0) {
			const { dataType } = this.attr.rawAttr;
			if (dataType === 'Date' || dataType === 'Datetime') {
				this.attr.selectedValues = moment();
			} else {
				this.attr.selectedValues = [''];
			}
		}

		this.editing = true;
	}

	setInstructions(help) {
		this.helpContent = { helpMe: help };
	}

	removeValue(index) {
		if (index <= this.attr.selectedValues.length) {
			this.attr.selectedValues.splice(index, 1);
		}
	}

	save() {
		if (!this.attributeFilterForm.$valid) {
			this.displayValidationError = true;
			this.validateForm();
			return;
		}
		this.addFilter({ attr: this.attr });
		if (this.parent && this.parent.closeModal) {
			this.parent.closeModal();
		}
	}

	remove() {
		this.removeFilter({ attr: this.attr });
		if (this.parent && this.parent.closeModal) {
			this.parent.closeModal();
		}
	}

	valuesValid() {
		return every(this.attr.selectedValues, value => value && value.length > 0);
	}

	addValue() {
		this.attr.selectedValues.unshift('');
		this.getFormField(0, 'value').$touched = false;
	}

	entryInvalid(index) {
		const form = this[`valueForm${index}`];
		return !!form && form.value && form.value.$touched && Object.keys(form.value.$error).length > 0;
	}

	supportsError(field) {
		return !!field && !!field.$error;
	}

	hasRequiredError($index, field = 'value') {
		const formField = this.getFormField($index, field);
		return this.supportsError(formField) && !!formField.$error.required;
	}

	getErrorType($index) {
		if (this.hasRequiredError($index)) {
			return 'required';
		}
		return null;
	}

	validateForm(form) {
		if (!form) {
			const forms = [];
			const rootForm = this.attributeFilterForm;
			Object.keys(rootForm).forEach(key => {
				const formProp = rootForm[key];
				if (formProp && formProp.$$parentForm) {
					forms.push(formProp);
				}
			});

			forms.forEach(this.validateFields);
		} else {
			this.validateFields(form);
		}
	}

	validateFields(form) {
		Object.keys(form).forEach(formKey => {
			const valueForm = form[formKey];
			if (valueForm && valueForm.$$parentForm) {
				Object.keys(valueForm).forEach(valueFormKey => {
					const field = valueForm[valueFormKey];
					if (!!field && field.$error && field.$setTouched && Object.keys(field.$error).length > 0) {
						field.$setTouched();
					}
				});
			}
		});
	}
}

export const attributeFilterComponent = {
	template,
	controller: AttributeFilterController,
	controllerAs: 'vm',
	require: {
		parent: '?^^modal'
	},
	bindings: {
		attr: '<',
		addFilter: '&',
		editFilter: '&',
		removeFilter: '&'
	}
};
